// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-support {
  padding: 20px;
}

.admin-support-header h1 {
  font-size: 24px;
  color: #051b2c;
  margin-bottom: 4px;
}

.admin-support-header p {
  color: #666;
  margin-bottom: 20px;
}

.admin-support-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: #666;
}

.admin-support-container {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 20px;
  height: calc(100vh - 200px);
  min-height: 500px;
}

/* Conversations Panel */
.conversations-panel {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  color: #051b2c;
}

.conversations-list {
  flex: 1 1;
  overflow-y: auto;
}

.conversation-item {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
}

.conversation-item:hover {
  background: #f9f9f9;
}

.conversation-item.active {
  background: #f0f0ff;
  border-left: 3px solid #4346ce;
}

.conv-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.conv-user {
  font-weight: 600;
  color: #051b2c;
  font-size: 14px;
}

.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  color: white;
  text-transform: capitalize;
}

.conv-preview {
  font-size: 13px;
  color: #666;
  margin: 0 0 6px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conv-date {
  font-size: 11px;
  color: #999;
}

.unread-indicator {
  position: absolute;
  right: 16px;
  bottom: 16px;
  background: #e54b4d;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
}

.no-conversations {
  padding: 40px 20px;
  text-align: center;
  color: #999;
}

/* Messages Panel */
.messages-panel {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.messages-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-info h3 {
  margin: 0;
  font-size: 16px;
  color: #051b2c;
}

.header-email {
  font-size: 12px;
  color: #666;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.close-conv-btn {
  padding: 8px 16px;
  background: #f3f3f3;
  border: none;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}

.close-conv-btn:hover {
  background: #e0e0e0;
}

.messages-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: #f9f9f9;
}

.message {
  display: flex;
  margin-bottom: 16px;
}

.message.user {
  justify-content: flex-start;
}

.message.admin {
  justify-content: flex-end;
}

.message-content {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 16px;
}

.message.user .message-content {
  background: white;
  border-bottom-left-radius: 4px;
}

.message.admin .message-content {
  background: #4346ce;
  color: white;
  border-bottom-right-radius: 4px;
}

.message-content p {
  margin: 0 0 6px 0;
  font-size: 14px;
  line-height: 1.4;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
}

.reply-container {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 12px;
}

.reply-container textarea {
  flex: 1 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  min-height: 60px;
}

.reply-container textarea:focus {
  outline: none;
  border-color: #4346ce;
}

.reply-container button {
  padding: 12px 24px;
  background: #4346ce;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
  align-self: flex-end;
}

.reply-container button:hover:not(:disabled) {
  background: #3538b2;
}

.reply-container button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.no-selection {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}

@media (max-width: 900px) {
  .admin-support-container {
    grid-template-columns: 1fr;
  }

  .conversations-panel {
    max-height: 300px;
  }
}


/* Attachment Styles */
.message-attachment {
  margin-bottom: 6px;
}

.attachment-image {
  max-width: 250px;
  max-height: 200px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.attachment-image:hover {
  transform: scale(1.02);
}

.voice-message {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.voice-message span {
  font-size: 13px;
}

.voice-message audio {
  max-width: 250px;
  height: 36px;
}

.file-attachment {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  color: #4346ce;
  text-decoration: none;
  font-size: 13px;
  transition: background 0.2s;
}

.file-attachment:hover {
  background: rgba(0, 0, 0, 0.1);
}

.message.admin .file-attachment {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.message.admin .file-attachment:hover {
  background: rgba(255, 255, 255, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminSupport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".admin-support {\n  padding: 20px;\n}\n\n.admin-support-header h1 {\n  font-size: 24px;\n  color: #051b2c;\n  margin-bottom: 4px;\n}\n\n.admin-support-header p {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.admin-support-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n  color: #666;\n}\n\n.admin-support-container {\n  display: grid;\n  grid-template-columns: 350px 1fr;\n  gap: 20px;\n  height: calc(100vh - 200px);\n  min-height: 500px;\n}\n\n/* Conversations Panel */\n.conversations-panel {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.panel-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.panel-header h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #051b2c;\n}\n\n.conversations-list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.conversation-item {\n  padding: 16px 20px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background 0.2s;\n  position: relative;\n}\n\n.conversation-item:hover {\n  background: #f9f9f9;\n}\n\n.conversation-item.active {\n  background: #f0f0ff;\n  border-left: 3px solid #4346ce;\n}\n\n.conv-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.conv-user {\n  font-weight: 600;\n  color: #051b2c;\n  font-size: 14px;\n}\n\n.status-badge {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  color: white;\n  text-transform: capitalize;\n}\n\n.conv-preview {\n  font-size: 13px;\n  color: #666;\n  margin: 0 0 6px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.conv-date {\n  font-size: 11px;\n  color: #999;\n}\n\n.unread-indicator {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  background: #e54b4d;\n  color: white;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 8px;\n}\n\n.no-conversations {\n  padding: 40px 20px;\n  text-align: center;\n  color: #999;\n}\n\n/* Messages Panel */\n.messages-panel {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.messages-panel .panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-info h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #051b2c;\n}\n\n.header-email {\n  font-size: 12px;\n  color: #666;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.close-conv-btn {\n  padding: 8px 16px;\n  background: #f3f3f3;\n  border: none;\n  border-radius: 6px;\n  color: #666;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.close-conv-btn:hover {\n  background: #e0e0e0;\n}\n\n.messages-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: #f9f9f9;\n}\n\n.message {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n.message.user {\n  justify-content: flex-start;\n}\n\n.message.admin {\n  justify-content: flex-end;\n}\n\n.message-content {\n  max-width: 70%;\n  padding: 12px 16px;\n  border-radius: 16px;\n}\n\n.message.user .message-content {\n  background: white;\n  border-bottom-left-radius: 4px;\n}\n\n.message.admin .message-content {\n  background: #4346ce;\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.message-content p {\n  margin: 0 0 6px 0;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.message-time {\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n.reply-container {\n  padding: 16px 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  gap: 12px;\n}\n\n.reply-container textarea {\n  flex: 1;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  resize: none;\n  font-family: inherit;\n  font-size: 14px;\n  min-height: 60px;\n}\n\n.reply-container textarea:focus {\n  outline: none;\n  border-color: #4346ce;\n}\n\n.reply-container button {\n  padding: 12px 24px;\n  background: #4346ce;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s;\n  align-self: flex-end;\n}\n\n.reply-container button:hover:not(:disabled) {\n  background: #3538b2;\n}\n\n.reply-container button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.no-selection {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #999;\n}\n\n@media (max-width: 900px) {\n  .admin-support-container {\n    grid-template-columns: 1fr;\n  }\n\n  .conversations-panel {\n    max-height: 300px;\n  }\n}\n\n\n/* Attachment Styles */\n.message-attachment {\n  margin-bottom: 6px;\n}\n\n.attachment-image {\n  max-width: 250px;\n  max-height: 200px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.attachment-image:hover {\n  transform: scale(1.02);\n}\n\n.voice-message {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.voice-message span {\n  font-size: 13px;\n}\n\n.voice-message audio {\n  max-width: 250px;\n  height: 36px;\n}\n\n.file-attachment {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  color: #4346ce;\n  text-decoration: none;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.file-attachment:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.message.admin .file-attachment {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.message.admin .file-attachment:hover {\n  background: rgba(255, 255, 255, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
